import axios from "axios";

const getTarjetas = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/TarjetasCredito/GetTarjetasCreditoActivas`, userData);
  return response.data;
};

const tarjetas = {
  getTarjetas,
};

export default tarjetas;
